import HanaCardJTRBanner from "assets/images/hana_jtr_banner.png";
import { HEADER_HEIGHT } from "const/layout";

const HanaJTRBgImage = () => {
  return (
    <div
      style={{
        position: "relative",
        top: `${HEADER_HEIGHT}px`,
        height: "calc(50vw)",
        width: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${HanaCardJTRBanner})`,
        maxWidth: "480px",
        margin: "auto",
        backgroundPosition: "center",
        maxHeight: "260px",
      }}
    />
  );
};

export default HanaJTRBgImage;
